import React, { useEffect } from "react";
import PropTypes from "prop-types";
import gql from "graphql-tag";
import { get } from "lodash";
import { useQuery } from "@apollo/react-hooks";
import LoadingIndicator from "../components/common/LoadingIndicator";
import {
  Card,
  CardTitle,
  PlanProducts,
  PlanPrice,
  Loading
} from "../styled/MlsBundle";
import { translate } from "../utils/locale";

const GET_BUNDLES_FOR_MLS_QUERY = gql`
  query getBundlesForMls($code: String!) {
    mls(code: $code) {
      id
      name
      bundles {
        key
        products {
          key
          name
          value
        }
      }
    }
  }
`;

function MlsBundle({ bundleKey, code, onLoad }) {
  const { loading, data } = useQuery(GET_BUNDLES_FOR_MLS_QUERY, {
    variables: { code }
  });
  const mls = get(data, "mls[0]", {});
  const bundles = get(mls, "bundles", []);
  const { products } = (bundles || []).find(
    (bundle) => bundle.key === bundleKey
  ) || { products: [] };
  const totalPrice = products.reduce(
    (total, product) => total + product.value,
    0
  );

  useEffect(() => {
    if (data) onLoad({ products, mls });
  }, [data]);

  return (
    <Card>
      <div>
        <CardTitle>
          Provided by{" "}
          <span
            dangerouslySetInnerHTML={{
              __html: translate("mls.label", "MLS").replace("®", "<sup>®</sup>")
            }}
          />
        </CardTitle>
        {loading && (
          <Loading>
            <LoadingIndicator />
            Loading...
          </Loading>
        )}
        {!loading && (
          <>
            <PlanProducts products={products} />
            <PlanPrice
              planKey={bundleKey}
              planPrice={totalPrice}
              finalPrice={0}
            />
          </>
        )}
      </div>
    </Card>
  );
}

MlsBundle.propTypes = {
  bundleKey: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  onLoad: PropTypes.func.isRequired
};

MlsBundle.defaultProps = {
  onLoad: () => {}
};

export default MlsBundle;
